import React, { createContext, useState } from 'react';

export const CatalogContext = createContext();

export const CatalogProvider = ({ children }) => {
    const [catalogItemsSearched, setCatalogItemsSearched] = useState([]);
    const [scrollY, setScrollY] = useState(null);
    const [searchRequest, setSearchRequest] = useState(null);
    const [savedSearchRequest, setSavedSearchRequest] = useState(null);

    return (
        <CatalogContext.Provider value={{ catalogItemsSearched, setCatalogItemsSearched, scrollY, setScrollY, searchRequest, setSearchRequest, savedSearchRequest, setSavedSearchRequest }}>
            {children}
        </CatalogContext.Provider>
    );
};